/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs */

const en_svc_full_stack_web_apps_architect_detail9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend + frontend + data model built in parallel and integrated early.`)
};

const ar_svc_full_stack_web_apps_architect_detail9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خلفية وواجهة أمامية ونموذج بيانات مبنية بالتوازي وتُدمج مبكرًا.`)
};

const bn_svc_full_stack_web_apps_architect_detail9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যাকএন্ড + ফ্রন্টএন্ড + ডেটা মডেল সমান্তরালে বানান, দ্রুত ইন্টিগ্রেট করুন।`)
};

const de_svc_full_stack_web_apps_architect_detail9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend + Frontend + Datenmodell parallel aufgebaut und frühzeitig integriert.`)
};

const es_svc_full_stack_web_apps_architect_detail9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend + frontend + modelo de datos construido en paralelo e integrado tempranamente.`)
};

const fr_svc_full_stack_web_apps_architect_detail9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend + frontend + modèle de données construits en parallèle et intégrés précocement.`)
};

const pt_svc_full_stack_web_apps_architect_detail9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend + frontend + modelo de dados construído em paralelo e integrado antecipadamente.`)
};

const zh_svc_full_stack_web_apps_architect_detail9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`后端、前端加数据模型并行开发、尽早联调。`)
};

const tr_svc_full_stack_web_apps_architect_detail9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arka uç + ön uç + veri modeli paralel kurulur, erken entegre edilir.`)
};

const ru_svc_full_stack_web_apps_architect_detail9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бэкенд + фронтенд + модель данных параллельно и ранняя интеграция.`)
};

const pl_svc_full_stack_web_apps_architect_detail9 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backend + frontend + model danych budowany równolegle i wcześnie zintegrowany.`)
};

/**
* | output |
* | --- |
* | "Backend + frontend + data model built in parallel and integrated early." |
*
* @param {Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_architect_detail9 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_architect_detail9(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_architect_detail9(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_architect_detail9(inputs)
	return en_svc_full_stack_web_apps_architect_detail9(inputs)
});
export { svc_full_stack_web_apps_architect_detail9 as "svc_full-stack-web-apps_ARCHITECT_detail" }